import { cn } from '@/lib/core/utils'

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-muted dark:bg-muted/50", className)}
      {...props}
    />
  )
}

export { Skeleton }
